import script from "./VideoContent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoContent.vue?vue&type=script&setup=true&lang=js"

import "./VideoContent.vue?vue&type=style&index=0&id=6cd5d6e6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd5d6e6"]])

export default __exports__